import React, { memo, useEffect, useRef, useState } from 'react';
import {
  APIProvider,
  Map,
  MapCameraChangedEvent,
  AdvancedMarker,
  Pin,
  useMapsLibrary,
  useMap,
} from '@vis.gl/react-google-maps';

/**
 * 设置行驶路线，如果距离较长，会以直线连接各点
    const traveledPath = [
        { lat: 37.422000, lng: -122.084058 },
        { lat: 37.563, lng: -122.325 },
    ];

    const traveledPolyline = new maps.Polyline({
        path: traveledPath,
        strokeColor: '#888',
        strokeOpacity: 1.0,
        strokeWeight: 4,
    });
    traveledPolyline.setMap(map);
 * 
 */

const MyComponent = () => {
  const map = useMap('container-map');
  const placesLib = useMapsLibrary('places');
  const routesLib = useMapsLibrary('routes');
  const coreLib = useMapsLibrary('core');
  const maps = useMapsLibrary('maps');

  // const { Route, RouteMatrix } = useMapsLibrary("routes");
  // const { Place } = useMapsLibrary("places");
  // const { LatLngBounds } = useMapsLibrary("core");

  useEffect(() => {
    if (!map || !placesLib || !routesLib || !coreLib || !maps) return;
    // Helper function to fit the map to the path.
    async function fitMapToPath(path) {
      const bounds = new coreLib.LatLngBounds();
      path.forEach((point) => {
        bounds.extend(point);
      });
      map.fitBounds(bounds);
    }

    const initMap = async () => {
      /**
             * travelMode options:
             'DRIVING'（驾车）
             'WALKING'（步行）
             'BICYCLING'（骑行）
             'TRANSIT'（公共交通）
             */
      const routeRequest2 = {
        origin: { lat: 37.422, lng: -122.084058 }, // 起点经纬度
        destination: { lat: 37.563, lng: -122.325 }, // 终点经纬度
        travelMode: 'DRIVING',
        fields: ['path', 'legs'],
      };

      const {
        routes: routes2,
        fallbackInfo: fallbackInfo2,
        geocodingResults: geocodingResults2,
      } = await routesLib.Route.computeRoutes(routeRequest2);

      const mapPolylines2 = routes2[0].createPolylines();

      // Add polylines to the map.
      mapPolylines2.forEach((polyline) => {
        polyline.strokeColor = '#888';
        polyline.setMap(map);
      });

      const routeRequest = {
        origin: { lat: 37.563, lng: -122.325 }, // 起点经纬度
        destination: { lat: 37.774929, lng: -122.419415 }, // 终点经纬度
        travelMode: 'DRIVING',
        fields: ['path', 'legs'],
      };

      // Call computeRoutes to get the directions.
      const { routes, fallbackInfo, geocodingResults } = await routesLib.Route.computeRoutes(routeRequest);

      // Use createPolylines to create polylines for the route.
      const mapPolylines = routes[0].createPolylines();

      // Add polylines to the map.
      mapPolylines.forEach((polyline) => {
        polyline.setMap(map);
      });

      // // Create markers to start and end points.
      // // update start and end text
      // const markers = await routes[0].createWaypointAdvancedMarkers();

      // // Add markers to the map
      // markers.forEach((marker) => {
      //     console.log('marker', marker);
      //     marker.setMap(map)
      // });

      // Fit the map to the path.
      fitMapToPath(routes[0].path!);
    };

    initMap();
  }, [map, maps, placesLib, routesLib, coreLib]);
  return <>...</>;
};

type Poi = { key: string; location: { lat: number; lng: number } };

const CurrentMarkerInner = () => {
  const [currentLocation, setCurrentLocation] = useState({ lat: 37.563, lng: -122.325 });

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentLocation((prevLocation) => ({
        lat: prevLocation.lat + 0.001,
        lng: prevLocation.lng + 0.001,
      }));
    }, 5000);

    return () => clearInterval(timer);
  }, []);
  return (
    <AdvancedMarker key='current' position={currentLocation}>
      <Pin background={'#FBBC04'} glyphColor={'#000'} borderColor={'#000'}>
        <span className='text-black'>current</span>
      </Pin>
    </AdvancedMarker>
  );
};

const CurrentMarker = memo(CurrentMarkerInner);

const Index = () => {
  const [initialized, setInitialized] = useState(false);

  const locations: Poi[] = [
    { key: 'start', location: { lat: 37.422, lng: -122.084058 } },
    { key: 'end', location: { lat: 37.774929, lng: -122.419415 } },
  ];

  const PoiMarkers = (props: { pois: Poi[] }) => {
    return (
      <>
        {props.pois.map((poi: Poi) => (
          <AdvancedMarker
            key={poi.key}
            position={poi.location}
            // onClick={() => console.log(`Marker ${poi.key} clicked`)}
          >
            <Pin background={'#FBBC04'} glyphColor={'#000'} borderColor={'#000'}>
              <span className='text-black'>{poi.key}</span>
            </Pin>
          </AdvancedMarker>
        ))}
      </>
    );
  };

  return (
    <APIProvider
      apiKey={'AIzaSyCqWSFk0ySDL4B-mwEnCwwf_7jdyfuSX90'}
      onLoad={() => setInitialized(true)}
      version='weekly'
      libraries={['marker', 'routes', 'core', 'places', 'maps']}
    >
      <Map
        id='container-map'
        mapId='b6269be552413cce4029d59f'
        defaultZoom={12}
        defaultCenter={{ lat: 37.447646, lng: -122.113878 }}
        mapTypeControl={false}
        onCameraChanged={(ev: MapCameraChangedEvent) => {
          // console.log('camera changed:', ev.detail.center, 'zoom:', ev.detail.zoom)
        }}
      >
        <CurrentMarker />
        <PoiMarkers pois={locations} />
      </Map>
      {initialized && <MyComponent />}
    </APIProvider>
  );
};

export default Index;
